import Step from './step';
import PhoneAuthCodeStep from './phone-auth-code-step';
import {createElement} from 'methods/utils';
import Select from 'components/select';
import IMask from 'imask';
import FormErrorsMixin from '../form-errors-mixin';

function PhoneAuthStep(modal, options = {}) {
    const className = 'PhoneAuthStep';
    const $element = createElement(
        `<div class="${className}">
            <div class="${className}__wrapper">
                <form action="/lk/request_code/" method="POST">
                    <div class="${className}__input-block">
                        <label class="${className}__input-label">Мобильный телефон</label>
                        <div class="${className}__input-group">
                            <div class="${className}__select-wrapper js-country-select-wrapper"></div>
                            <div class="${className}__input-wrapper">
                                <input class="${className}__input" type="tel" name="phone">
                            </div>
                        </div>
                        <div class="${className}__input-info">Отправим код подтверждения для входа</div>
                        <div class="g-recaptcha" data-sitekey="6LdTyrwlAAAAABkYA22tyid4pw42xjBMVHj7egLs"></div>
                    </div>
                    <button class="${className}__submit js-submit">Отправить код</button>
                    <div class="${className}__policy">
                        <p>Авторизуясь, вы соглашаетесь с правилами использования сервиса и обработки <a href="/about/guest_offer/">персональных данных</a>.</p>
                        <p><a href="https://privettur.ru/about/obrabotka_personalnyh_dannyh/" target="_blank">Политика в отношении обработки персональных данных</a></p>
                        <p><a href="https://privettur.ru/about/soglasie_na_obrabotku_personalnyh_dannyh/" target="_blank">Согласие на обработку персональных данных</a></p>
                    </div>
                </form>
            </div>
        </div>`
    );

    Step.call(this, modal, $element, options);
    FormErrorsMixin.call(this);

    this._authPromise = new Promise((resolve, reject) => {
        this._authPromiseResolve = resolve;
        this._authPromiseReject = reject;
    });

    this.$form = this.$element.querySelector('form');
    this.$form.addEventListener('submit', e => {
        e.preventDefault();
        this.submit();
    });

    this.$countrySelectWrapper = this.$element.querySelector('.js-country-select-wrapper');
    this.$phone = this.$element.querySelector('input[name="phone"]');
    this.$submit = this.$element.querySelector('.js-submit');

    this.formats = window.pageData.phone_formats.map(item => ({
        code: item.code,
        format: item.format,
        mask: item.format.replace(/\\d\{(\d+)\}/g, function(match, count) {
            return '0'.repeat(count);
        }),
    }));

    const items = this.formats.map(item => ({
        title: item.code,
        value: item.code,
    }));

    this.select = Select.make(items, {
        name: 'country',
        on: {
            select: (value, index) => {
                const format = this.formats.find(item => item.code == value);
                const startsWith = format.mask.match(/{?(\d+)}?/)[1];

                if (this.mask) {
                    this.mask.destroy();
                    this.$phone.value = '';
                }

                if (!this.$phone.value) {
                    this.$phone.value = startsWith;
                }

                this.mask = IMask(this.$phone, {
                    mask: format.mask,
                });
            },
        },
    });

    this.$countrySelectWrapper.appendChild(this.select.$element);
}

PhoneAuthStep.prototype = Object.create(Step.prototype);
Object.assign(PhoneAuthStep.prototype, FormErrorsMixin.prototype);
Object.defineProperty(PhoneAuthStep.prototype, 'constructor', {
    value: PhoneAuthStep,
    enumerable: false,
    writable: true,
});

PhoneAuthStep.prototype.auth = function(data) {
    if (data && data.country && data.phone) {
        this.select.setValue(data.country);
        this.mask.value = data.phone;
        this.submit();
    }

    return this._authPromise;
}

PhoneAuthStep.prototype.show = function() {
    this.modal.setTitle('Вход в личный кабинет');
    this.modal.setCanPrevStep(true);
    this.$phone.focus();
    this.getGoogleCaptchaToken();
}

PhoneAuthStep.prototype.getNextStep = function() {
    if (typeof this.nextStep == 'undefined') {
        this.nextStep = new PhoneAuthCodeStep(this.modal, {
            phone: this.$form.elements.phone.value,
        });
    }

    return this.nextStep;
}

PhoneAuthStep.prototype.getGoogleCaptchaToken = function() {
    // let captchaKey = '6Lezp7wlAAAAAK3OWdev_z2Ez4tU82jTVbXQ519U'; // numcard
    let captchaKey = '6LdTyrwlAAAAABkYA22tyid4pw42xjBMVHj7egLs'; // prod
    if (window.grecaptcha) {
        grecaptcha.ready(() => {
            let $recaptcha = document.querySelector('.g-recaptcha');

            if (!$recaptcha || $recaptcha.classList.contains('is-init') || $recaptcha.childElementCount) {
                return;
            }

            $recaptcha.classList.add('is-init');
            grecaptcha.render($recaptcha, {
                'sitekey' : captchaKey
            });
        });
    }

    return this.nextStep;
}

PhoneAuthStep.prototype.submit = function() {
    const formData = new FormData(this.$form);

    this.$submit.classList.add('is-loading');

    return fetch(this.$form.action, {
        method: this.$form.method,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        // обработка таймаута при активном коде (например пользователь перезагрузил страницу, "восстановление состояния таймаута")
        if (r.status == 'ok' || (r.status == 'error' && r.name == 'timeout')) {
            const step = this.getNextStep();
            step.startTimeout(r.timeout);
            this.showStep(step)
                .auth()
                .then(auth => {
                    this._authPromiseResolve(auth);
                });
        } else if (r.status != 'ok') {
            this.showFieldsErrors(r.fields);
        }
    }).finally(() => {
        this.$submit.classList.remove('is-loading');
    });
}

export default PhoneAuthStep;
